import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://28f682446a5de6e42c4f49bf118977f9@o4507113530785792.ingest.us.sentry.io/4510358451060736",

});
